import { render } from "./CashierItemElement.vue?vue&type=template&id=22616885&scoped=true"
import script from "./CashierItemElement.vue?vue&type=script&lang=js"
export * from "./CashierItemElement.vue?vue&type=script&lang=js"

import "./CashierItemElement.vue?vue&type=style&index=0&id=22616885&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22616885"]])

export default __exports__